import React, { FC, useEffect, useRef, useState } from 'react';
import { checkPaymentStatus } from '../services/visa.tsx';
import { useNavigate } from 'react-router-dom';
import { PaymentSkeleton } from '@bepro-travel/fe.shared';

const PaymentPage: FC = () => {
  const [data, setData] = useState<any>();
  const navigate = useNavigate();

  const timeout = useRef<any>();
  const [triesCount, setTriesCount] = useState(60);

  useEffect(() => {
    const newData = sessionStorage.getItem('orderPayment');
    if (newData) {
      const newDataObj = JSON.parse(newData);
      setData(newDataObj);

      check(newDataObj);
    }

    return () => clearTimeout(timeout.current);
  }, []); // eslint-disable-line

  const check = async (data: any) => {
    setTriesCount((prev) => prev - 1);

    const responseCheck = await checkPaymentStatus(data.transactionId);
    if (responseCheck?.orderHasBeenPaid) {
      sessionStorage.setItem(
        'orderSuccess',
        JSON.stringify({
          ...responseCheck.bookingModel,
          orderHasBeenPaid: responseCheck.orderHasBeenPaid,
        })
      );

      navigate('/success');
    } else if (responseCheck?.hasErrors) {
      sessionStorage.setItem('errMessage', responseCheck?.errorMessage);

      navigate('/fail');
    } else if (triesCount > 0) {
      timeout.current = setTimeout(() => check(data), 5000);
    }
  };

  return (
    <div
      className="details-wrapper position-relative"
      style={{
        justifyContent: 'center',
        height: 1100,
        display: 'flex',
        margin: 'auto',
      }}
    >
      <PaymentSkeleton systemProducts="Hotels" />
      {data?.paymentUrl && !data?.paymentUrl.includes('<iframe') && (
        <iframe
          src={data.paymentUrl}
          title="pay"
          width={500}
          height={1000}
          style={{ marginTop: 35, zIndex: 100 }}
        />
      )}

      {data?.paymentUrl && data?.paymentUrl.includes('<iframe') && (
        <div
          className="book-payment-wr"
          dangerouslySetInnerHTML={{ __html: data.paymentUrl }}
        ></div>
      )}
    </div>
  );
};

export default PaymentPage;
